import React, { FC } from 'react'
import PolaroidTextLink from '../PolaroidTextLink'

type PolaroidArtworkTitleProps = {
  onClick?: (ev: React.SyntheticEvent<Record<string, any>>) => void
  artworkTitleLink: string
  artworkTitle: string
  shouldOpenNewDesktopPdpTab?: boolean
}

const PolaroidArtworkTitle: FC<PolaroidArtworkTitleProps> = ({
  onClick,
  artworkTitleLink,
  artworkTitle,
  shouldOpenNewDesktopPdpTab,
}) => {
  const handleTitleOnClick = (ev: React.SyntheticEvent<Record<string, any>>) => {
    onClick?.(ev)
  }

  return (
    <>
      <PolaroidTextLink
        link={artworkTitleLink}
        onClick={handleTitleOnClick}
        shouldOpenNewTab={shouldOpenNewDesktopPdpTab}
        dataTestId='artwork-title'
        linkDataTestId='artwork-title-link'
        ariaLabel={`View ${artworkTitle}`}
      >
        {artworkTitle}
      </PolaroidTextLink>
    </>
  )
}

export default PolaroidArtworkTitle
